import { AppShell } from '../../components/layout/AppShell';
import { PageLayout } from '../../components/common/PageLayout';
import { ContentCard } from '../../components/common/ContentCard';
import { PAGE_COLORS } from '../../utils/pageColors';

export const ProductionDashboardPage: React.FC = () => {
  return (
    <AppShell>
      <PageLayout
        title="Production Dashboard"
        subtitle="In-depth production analytics and statistics"
        bgColor={PAGE_COLORS.production.bgColor}
        textColor={PAGE_COLORS.production.textColor}
        borderColor={PAGE_COLORS.production.borderColor}
        icon={<></>}
      >
        <ContentCard>
          <p className="text-gray-600">Production dashboard page coming soon...</p>
        </ContentCard>
      </PageLayout>
    </AppShell>
  );
};
